var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ctrl-select',{attrs:{"title":_vm.helpMessage,"optionInfoList":_vm.diceSystemList.map(function (systemObj) { return ({
      key: systemObj.system,
      value: systemObj.system,
      text: systemObj.system !== 'DiceBot' ? systemObj.name : '指定なし'
    }); }),"maxWidth":19,"disabled":_vm.disabled},model:{value:(_vm.currentSystem),callback:function ($$v) {_vm.currentSystem=$$v},expression:"currentSystem"}})}
var staticRenderFns = []

export { render, staticRenderFns }